module.exports = __webpack_public_path__ + "img/az_quanqiugou_logo.8e40e6e0.png";